export default {
  namespaced: true,
  state: () => ({
    selectedProjectType: '',
    selectedDebrisType: [],
    selectedFillType: '',
    zip: '',
    showProjectTypeTiles: false
  }),
  mutations: {
    selectedProjectType (state, payload) {
      state.selectedProjectType = payload
      // Reset debris and fill types on project change
      state.selectedDebrisType = []
      state.selectedFillType = ''
    },
    selectedDebrisType (state, payload) {
      state.selectedDebrisType = payload
    },
    selectedFillType (state, payload) {
      state.selectedFillType = payload
    },
    showProjectTypeTiles (state, payload) {
      state.showProjectTypeTiles = payload
    }
  },
  getters: {
    selectedFillType (state) {
      // Only return a fill type if the selected debris type was heavy
      return state.selectedDebrisType.includes('heavy') ? state.selectedFillType : ''
    },
    readyForMako (state, getters, rootState) {
      const { isServiceAddressValid } = rootState.customer
      const { selectedDebrisType, selectedFillType } = state
      const isHeavy = state.selectedDebrisType.includes('heavy')
      const hasAllInfo = isServiceAddressValid && selectedDebrisType.length

      // Make sure heavy has a fill type
      if (isHeavy && selectedFillType && hasAllInfo) {
        return true
      }

      if (!isHeavy && hasAllInfo) {
        return true
      }

      return false
    }
  }
}
